module.exports = __webpack_public_path__ + "assets/img/answerIcon.5e07e3e7.png";